// jshint esversion: 6
import $ from 'jquery'
import 'babel-polyfill'
import Foundation from './_foundation'
import 'motion-ui/dist/motion-ui'
// import 'aos/dist/aos'
import AOS from 'aos'
import './_acf-map'
import './_defer-oembed'
import './_defer-video'
import './_fixed-header'
import './_hero-slider'
import './_notification'
import './_scroll-to-top'
import './_skip-link-focus-fix'
import './_background-video'
import './_related-projects'
import './_ie-detection'
import './parallax.js'
import './lazy-background'

// Slick
import './_slick'

// Off-canvas
import './_off-canvas'

// Fragment URLs
// import './_fragmentURLs'

// Header Height
import './_header-height'

// init Foundation
$(document).foundation();

// Detect Modal is Open
$( '[data-reveal]' ).on( 'open.zf.reveal', function() {
    
    var $modal = $(this),
        $overlay = $modal.parent();

    $overlay.prepend('<button class="close-button close-button--outside" aria-label="Close alert" type="button"><span aria-hidden="true">&times;</span></div>');

} );

// Push SVG to inline so we can edit them
$('img.svg').each(function() {
    let $this = $(this)
    $.get($this.attr('src'), function(data) {
        let $svg = $(data).find('svg').removeAttr('xmlns:a')
        $this.replaceWith($svg)
    }, 'xml')
})

// FAQ - accordion layout
$('.js-faq-question').click(function(e) {
    e.preventDefault();

    let $question = $(this);
    let $answer = $question.siblings( '.js-faq-answer' );

    $question.stop().toggleClass( 'is-open' );
    $answer.stop().slideToggle();
});

// Blog Search Focus State
var $blog_search_input = $( '.search-form__input' ), 
    $blog_search_button = $( '.search-form__button' );

function searchControlActiveHandler() {
    $(this).parent().addClass('active');
    return true;
}

function searchControlInActiveHandler() {
    if ( $(this).parent().hasClass('active') ) {
        $(this).parent().removeClass('active');
    }
    return false;
}

$blog_search_input.focus( searchControlActiveHandler );
$blog_search_input.blur( searchControlInActiveHandler );

//** Document is ready...

jQuery( function( $ ) {

    // Off Canvas Menu - Display all links

    $( '.off-canvas__menu .menu-item-has-children > .js-submenu-slider' ).trigger('click');

    // Prevent Jump
    
    $('button[data-open]').on( 'click', function(event) {
        event.preventDefault();
    } );

    // Ajax Load More

    (function() {
      $.fn.almComplete = function(alm){
        $(window).trigger('resize');
        setTimeout( function() {
            $(window).trigger('resize');
        }, 250 );
      };
    })(jQuery);

    // Fade in Site Content - Refer to _base.scss

    $(window).on('load', function() {
        $('.site-content').addClass('loaded');
        setTimeout( function() {
            $(window).trigger('resize');
        }, 500 );
    });
    
    // After Disqus loads then trigger a window resize to fix parrallax

    var interval = setInterval(function() {
        var $ = jQuery;
        var disqusHeight = $('#disqus_thread').height();
        if ( disqusHeight > 52 ) {  // height 52px is header of Disqus, more than 52px means that disqus load comments
            
            setTimeout(function() {
                $(window).trigger('resize');
            },500);

            clearInterval(interval); // after loaded comment we stop this script
        }
    }, 100);
    
    // AOS

    AOS.init();

    // Detect Modal is Open

} );


